import React,{useState,useEffect} from 'react';
import {Row,Col,Button,Form, Spinner, Badge} from 'react-bootstrap';
import { RightSidebarNuevaCotizacion } from '../RightSidebar/RightSidebar';
import { useSelector,useDispatch,getState } from 'react-redux';
import { setInitData,setStateHome, setStateGlobal, } from '../../reducers/appReducer';
import './NuevaCotizacion.css';
import '../Directory/Directory.css';

import { number_format, uniqid, } from "../../utils/utils";
import moment from "moment";
import "moment/locale/es";

moment.locale("mx");

const reminder = moment().add(2, 'days').format('DD/MM/YYYY') + ' 1:00 PM'

function _GET(variable) {
  let query = window.location.search.substring(1);
  let vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split('=');
    if (decodeURIComponent(pair[0]) == variable) {
      return decodeURIComponent(pair[1]);
    }
  }
  return '';
}

export const NuevaCotizacion = ({socket, usuario}) => {

  const stateGlobal = useSelector( (state) => state.agents );
  const stateHome = stateGlobal.home;
  
  const dispatch = useDispatch();

  let [service,setService] = useState([])

  const [sidebar,setSidebar] = useState(false);
  const [dependencias,setDependencias] = useState([]);

  const [arrPreCotizacion,setPreCotizacion] = useState([]);

  const [servicios,setServicios] = useState([]);
  const [requisitos,setRequisitos] = useState([]);
  const [indexCategoria,setIndexCategoria] = useState(-1);
  const [indexDependencia,setIndexDependencia] = useState(-1);
  const [indexServicios,setIndexServicios] = useState(-1);

  const [arrMultiCotizacion, setMultiCotizacion] = useState([]);

  const [btnLoadingAgregar,setBtnLoadingAgregar] = useState(false);

  const [idUser,setIdUser] = useState("");
  const [data,setData] = useState({
    indexCategoria: '',
    indexDependencia: '',
    indexServicios: '',
    id_usuario: '',
    id_cotizacion: uniqid(),
    formulario: [],
    dataSearch:'',
    formaPago: 'Efectivo',
    metodoPago: 'contado',
    costo: 0,
    nombreCliente: 'cargando...',
    totalDeuda: 0,
    totalCotizaciones: 0,
    vendedor: '',
  })

  const [arrClientes,   setClientes] = useState([]);
  const [arrEjecutivos, setEjecutivos] = useState([]);
  const [arrVendedores, setVendedores] = useState([]);

  const getDirectorioNuevo = () => {
    const data = {  }
    fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=getDirectorioNuevo',{
      method: 'POST',
      model: 'cors',
      body: JSON.stringify(data)
    })
    .then( response => response.json())
    .then( res => {

      setClientes( res.clientes.documents )
      setEjecutivos( res.ejecutivos.documents )
      setVendedores( res.vendedores.documents )
    })
  }

  useEffect(() => {
    setService(stateGlobal.arrTramites)
  },[stateGlobal.arrTramites])


  useEffect( () => {
    getDirectorioNuevo()
    if(_GET('id')!==''){
      setData({...data, id_usuario: _GET('id'), })
      setIdUser(_GET('id'));
      getHistorialClienteByID( _GET('id') )
    }

    setService(stateGlobal.arrTramites)
  }, [])

  const getHistorialClienteByID = (id_cliente) => {

    const _data = {
      id_cliente,
    }

    fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=getHistorialClienteById',{
      method: 'POST',
      mode:'cors',
      body: JSON.stringify(_data)
    })
    .then( response => response.json())
    .then( response => {
      // console.log(response)
      const newData = {...data};  
      newData.nombreCliente = response.cliente.nombre_completo
      // newData.arrCotizaciones = response.cotizaciones
      newData.documents = response.documents
      newData.vendedor = response.cliente.vendedor;

      let totalDeuda = 0,
      totalCotizaciones = 0,
      totalPagos = 0,
      totalCantidadCotizacion = 0

      newData.documents.map((t,e) => {

        if(t.id_cliente === _GET('id')) {
          totalCantidadCotizacion += parseFloat( t.cantidad )
          totalCotizaciones++

          if(t.arrCobranza.length > 0) {

              t.arrCobranza.map((t0,e0) => {
                totalPagos += parseFloat(t0.cantidadRecibida)
              })
          }
        }

      })

      // console.log('aquí ', totalCantidadCotizacion, totalPagos)
      newData.totalDeuda = totalCantidadCotizacion - totalPagos
      newData.totalCotizaciones = totalCotizaciones
      newData.totalPagos = totalPagos
      newData.totalCantidadCotizacion = totalCantidadCotizacion

      setData(newData);
    })
  }


  const handleSubmitForm = () => {

    setBtnLoadingAgregar(true);

    if(data.vendedor===''){
      alert('Selecciona un vendedor');
      setBtnLoadingAgregar(false);
      return false;
    }

    const serviceName = stateGlobal.arrTramites[indexCategoria].categoria;

    for(var a in arrMultiCotizacion) {
      const _item = arrMultiCotizacion[a]

      const newArr = []
      for(var a in _item.requisitos) {
        newArr.push({
          ..._item.requisitos[a],
          id: a+1,
          value: ""
        })
      }

      // Antes estaba así -> const item = service[ data.indexDependencia ]
      const item = service[ data.indexCategoria ]

      const id_cotizacion = uniqid(),
      formNew = {
        id_cotizacion,
        id_cliente: _GET('id'),

        nombre_tipo: item.dependencias[data.indexDependencia].nombre,
        departamento: item.nombre,
        numero: 'PRUEBA',
        oficina: 'OFICINA - TIJUANA',
        // reminder,
        created_at: moment().format('YYYY-MM-DD HH:mm:ss'),
        concepto: 'TRÁMITES',
        concepto2: servicios[_item.indexServicios].nombre,
        
        cantidad: data.costo,
        costo_dependencia: data.costo_dependencia,
        costo_honorario: data.costo_honorario,

        metodo_pago: data.metodoPago,
        forma_pago: data.formaPago,
        authorization_finanzas: (data.metodoPago=='contado') ? true : false,
        vendedor: data.vendedor,
        vendedor_nombre: arrVendedores.filter( element => element['_id'] == data.vendedor )[0]['nombre_completo'],
        departamento: serviceName,
        atn_creado: usuario.nombre,
        tramite_iniciado : (data.metodoPago === 'contado') ? false : true
      }

      fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=saveTramite',{
        method: 'POST',
        mode:'cors',
        body: JSON.stringify(formNew)
      })
      .then( response => response.json())
      .then( response => {
        // window.location.href = "/";
      //  socket.emit("toCajero", { client: 'hgapp', substrace: 'updateCost', }) 
      })

      fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=saveTramiteOt',{
        method: 'POST',
        mode:'cors',
        body: JSON.stringify(
          {
            id_cotizacion,
            info: newArr,
            arrProcess: [
              { view: true, cotizaciones: true, id: 'cotizaciones', nombre: 'CO', status: data.metodoPago === 'contado' ? 1 : 2, },
              { view: true, orden_trabajo: true, id: 'orden_trabajo', nombre: 'OT', status: data.metodoPago === 'contado' ? 0 : 0, },
              { view: false, caja: false, id: 'caja', nombre: 'CA', status: data.metodoPago === 'contado' ? 0 : 1, },
              { view: false, finanzas: false, id: 'finanzas', nombre: 'FZ', status: data.metodoPago === 'credito' ? 1 : 0, },
              { view: false, procesos: false, id: 'procesos', nombre: 'PR', status: 0, },
            ],
            arrHistory: [
              { usuario_nombre: usuario.nombre, fecha: moment().format('YYYY-MM-DD HH:mm:ss'), motivo: "Inició este trámite.", id: 'cotizaciones', },
            ]

          }
        )
      })
      .then( response => response.json())
      .then( response => {
        window.location.href = "/"; 
        // setBtnLoadingAgregar(false);
        // socket.emit("toCajero", { client: 'hgapp', substrace: 'updateCost', }) 
        // console.log(response);
      })

      if(a == (arrMultiCotizacion.length - 1)) {

        // console.log('termineeee')
        setTimeout( ( ) => {
          window.location = '/'
        }, 3000 )
      }

    }

  }

  const searchServicios = (e) => {
    const textSearch = e.target.value;
    let dataSearchFilter = [];
    let dataSearchCategoria = [];
    setIndexDependencia(-1);
    setIndexCategoria(-1);
    setIndexServicios(-1);
    setData({
      ...data,
      formulario: []
    })
    
    for(let i = 0; i < service.length; i++){
      let dependencias = service[i].dependencias;
      for(let j = 0; j < dependencias.length; j++){
        let servicios = dependencias[j].servicios;
        for(let k = 0; k < servicios.length; k++){
            if(servicios[k].nombre.toLowerCase().indexOf(textSearch.toLowerCase()) > -1){
            // dataSearchFilter = [];
            dataSearchFilter.push(servicios[k]);
            dataSearchCategoria.push(dependencias[j]);
          }
        }

      }
    }
    setIndexDependencia(1000);
    setIndexCategoria(1000);
    setDependencias(dataSearchCategoria);
    setServicios(dataSearchFilter);
  }

  const selectToPrecotizacion = (item) => {

    let indexNotAdd = -1
    for( var a in arrPreCotizacion ) {

      if(arrPreCotizacion[a].nombre === item.nombre)
        indexNotAdd = a
    }

    if (item.costo_dependencia) {
      if(indexNotAdd === -1)
        arrPreCotizacion.push(item)
      else {
        arrPreCotizacion.splice(indexNotAdd, 1)
      }
    }

    setPreCotizacion(arrPreCotizacion)
  }

  const setToAddMulticotizacion = (item, index) => {
    /*
    let indexNotAdd = -1
    for( var a in arrMultiCotizacion ) {

      if(arrMultiCotizacion[a].nombre === item.nombre)
        indexNotAdd = a
    }

    if (item.nombre) {
      if(indexNotAdd === -1) {
    */
        arrMultiCotizacion.push({
          ...item,
          indexServicios: index
        })
    /*
        console.log('agregado...' , arrMultiCotizacion)
      } else {
        arrMultiCotizacion.splice(indexNotAdd, 1)
      }
    }
    */

    setMultiCotizacion(arrMultiCotizacion)
  }

  let totalDependencia = 0
  let totalHonorarios = 0
  arrPreCotizacion.map((t) => {
    totalDependencia += t.costo_dependencia
    totalHonorarios += t.costo_honorario
  })

  return(
    <div className="container-fluid">
      <div className="ws-main-container-directorio">

        <Row className="mb-3"> 
          <Col xs={12}>
            <Button className="ws-btn-blue-2"
            onClick={ () => {
              window.location.href = "/"
            }}
            ><i className="bi bi-arrow-left"></i>&nbsp;Atrás</Button> 
          </Col>
        </Row>

        <Row className="mt-3 mb-3">
          {
            data.nombreCliente === 'cargando...'
            ? <Col className="d-flex justify-content-center"><Spinner animation='border' size='lg' variant='danger'/></Col>
            : (
                <React.Fragment>
                  <Col><h4>{data.nombreCliente}</h4></Col>
                  <Col><h4>Total cotizaciones: {data.totalCotizaciones}</h4></Col>
                  <Col><h4>Total adeudo: <b>${number_format(data.totalDeuda, 2)}</b></h4></Col>
                </React.Fragment>
            )
          }
        </Row>

        {/* Formulario de búsqueda por filtro ingresado */}
        <Row className="mt-3 mb-3">
          <Col xs={12}> 
            <Form onSubmit={ (e) => e.preventDefault() }>
              <Form.Group className="group-search">
                <i className="bi bi-search pe-2"></i>
                <Form.Control 
                type="search"
                className="ws-input-search"
                placeholder="Buscar servicio..."
                value={data.dataSearch}
                onChange={ (e) => setData({
                  ...data,
                  dataSearch: e.target.value
                }) }
                onKeyDown={searchServicios}
                />
              </Form.Group>
            </Form>
          </Col>
          <Col xs={1}>
            <div className="ws-group-icons-tools d-flex justify-content-center align-items-center">
            </div>
          </Col>
        </Row>

        {
          totalHonorarios > 0 && (
            <Row className="mt-3 mb-3">
              <Col><p>Costo de trámite dependencias: <b style={{color:"#ff0350"}}>${number_format(totalDependencia)}</b></p></Col>
              <Col><p>Costo de honorarios: <b style={{color:"#ff0350"}}>${number_format(totalHonorarios)}</b></p></Col>
              <Col><p>Costo de total: <b style={{color:"#ff0350"}}>${number_format(totalDependencia + totalHonorarios)}</b></p></Col>
            </Row>
          )
        }

        <Row>

          <Col xs={3} className={(indexCategoria!==-1) ? 'ws-column-divider' : ''}>
            <h2 className="ws-column-title">Departamento</h2>
            <ul className="ws-column-list">
              {
                service.map((t,e) => (
                <li key={`list-${e}`} className={`ws-list-categoria ${(indexCategoria===e) ? 'active' : ''} `}
                onClick={ () => {
                  setData({...data,indexCategoria:e})
                  setIndexCategoria(e);
                  setIndexDependencia(-1);
                  setIndexServicios(-1);

                  const newDependencias = [...t.dependencias];

                  newDependencias.sort((a, b) => {
                    const nombreA = a.nombre.toUpperCase(); // Convertir a mayúsculas para evitar errores de ordenamiento
                    const nombreB = b.nombre.toUpperCase();
                    if (nombreA < nombreB) {
                      return -1;
                    }
                    if (nombreA > nombreB) {
                      return 1;
                    }
                    return 0;
                  });

                  setDependencias(newDependencias)
                  setServicios([]);
                  setRequisitos([]);
                } }
                >{t.categoria} {(indexCategoria===e) && <i className="bi bi-chevron-right icon-list-right"></i>} </li> 
                ))
              } 
            </ul>
          </Col>

          <Col xs={3} className={(indexDependencia!==-1) ? 'ws-column-divider' : ''}>
            {
                <h2 className="ws-column-title">Selecciona una dependencia</h2>
            }
            <ul className="ws-column-list">
              {
                dependencias.map((t,e) => (
                  <li key={`list-${e}`} className={`ws-list-categoria ${(indexDependencia===e) ? 'active' : ''} `}
                  onClick={ () => {
                    setData({...data,indexDependencia:e})
                    setIndexDependencia(e);
                    setIndexServicios(-1);
                    setServicios(t.servicios);
                    setRequisitos([]);
                  } }
                  >{t.nombre} {(indexDependencia===e) && <i className="bi bi-chevron-right icon-list-right"></i>}</li> 
                ))
              }
            </ul>
          </Col>
          <Col xs={3} className={(indexServicios!==-1) ? 'ws-column-divider' : ''}>
            {
                <h2 className="ws-column-title">Selecciona un servicio</h2>
            }
            <ul className="ws-column-list">
              {
                servicios.map((t,e) => (
                  <li key={`list-${e}`} className={`ws-list-categoria ${(indexServicios===e) ? 'active' : ''} `}
                  onClick={ () => {

                    setToAddMulticotizacion(t,e)

                    setIndexServicios(e);
                    setRequisitos(t.requisitos)
                    selectToPrecotizacion(t)

                    let newData = t.requisitos
                    setData({
                      ...data,
                      formulario: newData,
                      indexServicios: e,
                      costo: t.costo_dependencia ? (t.costo_honorario + t.costo_dependencia) : t.costo_honorario ? t.costo_honorario : 0,
                      costo_dependencia: t.costo_dependencia ? t.costo_dependencia : 0,
                      costo_honorario: t.costo_honorario ? t.costo_honorario : 0,
                    })
                  } }
                  >
                  {t.nombre}
                  {t.costo_honorario && <Badge bg='danger' pill className={'ws-list-categoria-badge'}>{t.costo_honorario ? 'Tiene costo' : null}</Badge>}
                  {(indexServicios===e) && <i className="bi bi-chevron-right icon-list-right"></i>}</li> 
                ))
              }
            </ul>
          </Col>
          <Col xs={3}>
            {
                <h2 className="ws-column-title">Requisitos</h2>
            }
            <ul className="ws-column-list">
              {
                data.formulario.map((t,e) => (
                  <div key={`list-${e}`} style={{ position: 'relative' }}>
                    <li className="ws-list-categoria item-80 not-select"
                    onClick={ () => console.log(e.nombre) }
                    >{t.nombre}</li>
                    <Badge 
                      className='ws-list-categoria-badge'
                      bg='danger'
                      pill
                    >{t.tipo === 'text' ? 'Texto' : 'Archivo'}</Badge>
                  </div>
                ))
              }
            </ul>
            {
              (indexServicios!==-1) && (
                <div className="d-grid gap-2">
                  <p>Costo del trámite: <b>${number_format( data.costo )} USD</b></p>
                  { data.costo_dependencia > 0 && <p style={{ fontSize: '.8rem', margin: 0, }}>Costo dependencia: <b>${number_format( data.costo_dependencia )} USD</b></p> }
                  { data.costo_honorario > 0 && <p style={{ fontSize: '.8rem', margin: 0, }}>Costo honorario: <b>${number_format( data.costo_honorario )} USD</b></p> }
                  <Button className="ws-btn-blue-2" onClick={() => setSidebar(true) }>Seleccionar</Button>
                </div>
              )
            }
          </Col>

          <RightSidebarNuevaCotizacion 
          status={sidebar} 
          setStatus={setSidebar} 
          title="Nueva Cotización" 
          onClose={()=>console.log('close sidebar')} 
          onSave={ () => handleSubmitForm() } 
          loading={btnLoadingAgregar}
          >
            <Form>
              <Row className="ws-form-group-divider pb-3 pt-3">
                {/* <hr /> */}
                {/* <p>* Estos son los registros que se deberán rellenar en la orden de trabajo.</p>
                {
                  requisitos.map((t,e) => (
                    <Col key={`list-${e}`} xs={12} lg={6}>
                      <Form.Group className="mb-2">
                        <Form.Label className="ws-form-label" style={{ fontStyle: 'italic', }}>  
                          {t.nombre} ({t.tipo === 'file' ? 'Archivo' : 'Texto'})
                        </Form.Label>
                      </Form.Group>
                    </Col>
                  ))
                }
                <hr /> */}

                <Form.Group className="mb-3">  
                  <Form.Label>Vendedor</Form.Label>
                  <Form.Select value={data.vendedor} onChange={ (e) => { setData({...data, vendedor: e.target.value}) } }>
                    <option value="">Selecciona un vendedor</option>
                    {
                      (arrVendedores && arrVendedores.length > 0) ?
                        arrVendedores.map((t,e) => (
                          <option value={t["_id"]} key={`id-${e}`}>{t.nombre_completo}</option>
                        ))
                      : null
                    }
                  </Form.Select>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Método de pago</Form.Label>
                  <Form.Select onChange={(ev) => { setData({ ...data, metodoPago: ev.target.value}) } }> 
                    <option select={'selected'} disabled={'disabled'}>Elige el método de pago</option>
                    <option value={'contado'}>Contado</option>
                    <option value={'credito'}>Crédito</option>
                  </Form.Select>
                </Form.Group>

                {
                  (dependencias[indexDependencia]?.nombre === 'IRS - Internal Revenue Services') ?
                    <>
                    <hr />
                    <Form>
                      <Form.Group className="mb-3">
                        <Form.Select>
                          <option disabled>Elige el mes del trámite</option>
                          <option>Enero ($275.00)</option> 
                          <option>Febrero ($229.17)</option> 
                          <option>Marzo ($183.33)</option> 
                          <option>Abril ($137.50)</option> 
                          <option>Mayo ($91.67)</option> 
                          <option>Junio ($45.83)</option> 
                          <option>Agosto ($504.17)</option> 
                          <option>Septiembre ($458.33)</option> 
                          <option>Octubre ($412.50)</option> 
                          <option>Noviembre ($366.67)</option> 
                          <option>Diciembre ($320.83)</option> 
                        </Form.Select>
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label>Vehículos con impuesto</Form.Label>
                        <Form.Control />
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label>Vehículos sin impuesto</Form.Label>
                        <Form.Control />
                      </Form.Group>
                    </Form>
                    </>
                  : null
                }

                {
                  (dependencias[indexDependencia]?.nombre === 'CBP - Customs and Border Protection') ?
                  <>
                  <hr />
                  <Form>  
                    <Form.Group className="mb-3">
                      <Form.Label>Número de unidades</Form.Label>
                      <Form.Control type="text" name="numero_unidades" id="numero_unidades" />
                    </Form.Group>
                  </Form>
                  </>
                  : null
                }

                {
                  /*
                    <Form.Group className="mb-3">
                      <Form.Label>Costo total de trámite</Form.Label>
                      <Form.Control value={data.costo} type="text" placeholder="Ingresa el costo total" onChange={ (ev) => { setData({ ...data, costo: ev.target.value, }) }} />
                    </Form.Group>
                  */
                }

                {/* <p>Forma de pago</p>
                <select onChange={(ev) => { setData({ ...data, formaPago: ev.target.value}) } }>
                  <option select={'selected'} disabled={'disabled'}>Elige la forma de pago</option>
                  <option value={'Efectivo'}>Efectivo</option>
                  <option value={'Cheque'}>Cheque</option>
                  <option value={'Transferencia interbancaria'}>Transferencia interbancaria</option>
                  <option value={'Tarjeta de crédito'}>Tarjeta de crédito</option>
                  <option value={'Tarjeta de débito'}>Tarjeta de débito</option>
                </select> */}
              </Row>
            </Form>
          </RightSidebarNuevaCotizacion>

        </Row>
      </div>
    </div> 
  )
}
